import { isElement, isFragment } from 'react-is';
export function childrenToElementArray(children) {
  var childrenArray = Array.isArray(children) ? children : [children];
  return childrenArray.filter(function (node) {
    return isElement(node) || isFragment(node) || typeof node === 'string';
  });
}